/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { ConfirmDiagnosisRequestDto } from '../model/confirmDiagnosisRequestDto';
// @ts-ignore
import { CreateDiagnosisRequestDto } from '../model/createDiagnosisRequestDto';
// @ts-ignore
import { DiagnosesControllerCreate200Response } from '../model/diagnosesControllerCreate200Response';
// @ts-ignore
import { DiagnosesControllerList200Response } from '../model/diagnosesControllerList200Response';
// @ts-ignore
import { DiagnosesControllerSearch200Response } from '../model/diagnosesControllerSearch200Response';
// @ts-ignore
import { PatchDiagnosisRequestDto } from '../model/patchDiagnosisRequestDto';
// @ts-ignore
import { RuleOutDiagnosisRequestDto } from '../model/ruleOutDiagnosisRequestDto';
// @ts-ignore
import { UpdateDiagnosisRequestDto } from '../model/updateDiagnosisRequestDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class DiagnosesService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Confirm diagnosis
   * @param id 
   * @param confirmDiagnosisRequestDto 
   */
  public async diagnosesControllerConfirm(id: string, confirmDiagnosisRequestDto: ConfirmDiagnosisRequestDto, ): Promise<DiagnosesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling diagnosesControllerConfirm.');
    }
    if (confirmDiagnosisRequestDto === null || confirmDiagnosisRequestDto === undefined) {
      throw new Error('Required parameter confirmDiagnosisRequestDto was null or undefined when calling diagnosesControllerConfirm.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/confirm`,
        data: confirmDiagnosisRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Create a diagnosis
   * @param createDiagnosisRequestDto 
   */
  public async diagnosesControllerCreate(createDiagnosisRequestDto: CreateDiagnosisRequestDto, ): Promise<DiagnosesControllerCreate200Response> {
    if (createDiagnosisRequestDto === null || createDiagnosisRequestDto === undefined) {
      throw new Error('Required parameter createDiagnosisRequestDto was null or undefined when calling diagnosesControllerCreate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses`,
        data: createDiagnosisRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Delete diagnosis
   * @param id 
   */
  public async diagnosesControllerDelete(id: string, ): Promise<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling diagnosesControllerDelete.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.delete({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get diagnosis by ID
   * @param id 
   * @param expand Fields to expand in the response
   */
  public async diagnosesControllerGetById(id: string, expand?: Array<'diagnosis-type'>, ): Promise<DiagnosesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling diagnosesControllerGetById.');
    }

    const localVarQueryParameters = new URLSearchParams();
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List diagnoses
   * @param patientId Filter by patient ID
   * @param encounterId Filter by encounter ID
   * @param elementId Filter by diagnosis type element ID
   * @param status Filter by status(es) - accepts comma-separated values (e.g., confirmed,preliminary)
   * @param priority Filter by priority
   * @param onsetDateFrom Filter by onset date from
   * @param onsetDateTo Filter by onset date to
   * @param limit Number of items per page
   * @param offset Number of items to skip
   * @param expand Fields to expand in the response
   */
  public async diagnosesControllerList(patientId?: string, encounterId?: string, elementId?: string, status?: Array<'preliminary' | 'confirmed' | 'differential' | 'ruled_out' | 'resolved'>, priority?: 'primary' | 'secondary' | 'tertiary', onsetDateFrom?: string, onsetDateTo?: string, limit?: number, offset?: number, expand?: Array<'diagnosis-type'>, ): Promise<DiagnosesControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (patientId !== undefined && patientId !== null) {
      localVarQueryParameters.append('patientId', String(patientId));
    }
    if (encounterId !== undefined && encounterId !== null) {
      localVarQueryParameters.append('encounterId', String(encounterId));
    }
    if (elementId !== undefined && elementId !== null) {
      localVarQueryParameters.append('elementId', String(elementId));
    }
      if (status) {
        status.forEach((element) => {
          localVarQueryParameters.append('status', String(element));
        });
    }
    if (priority !== undefined && priority !== null) {
      localVarQueryParameters.append('priority', String(priority));
    }
    if (onsetDateFrom !== undefined && onsetDateFrom !== null) {
      localVarQueryParameters.append('onsetDateFrom', String(onsetDateFrom));
    }
    if (onsetDateTo !== undefined && onsetDateTo !== null) {
      localVarQueryParameters.append('onsetDateTo', String(onsetDateTo));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses?${queryString}` : `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Partially update diagnosis
   * @param id 
   * @param patchDiagnosisRequestDto 
   */
  public async diagnosesControllerPatch(id: string, patchDiagnosisRequestDto: PatchDiagnosisRequestDto, ): Promise<DiagnosesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling diagnosesControllerPatch.');
    }
    if (patchDiagnosisRequestDto === null || patchDiagnosisRequestDto === undefined) {
      throw new Error('Required parameter patchDiagnosisRequestDto was null or undefined when calling diagnosesControllerPatch.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.patch({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: patchDiagnosisRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Rule out diagnosis
   * @param id 
   * @param ruleOutDiagnosisRequestDto 
   */
  public async diagnosesControllerRuleOut(id: string, ruleOutDiagnosisRequestDto: RuleOutDiagnosisRequestDto, ): Promise<DiagnosesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling diagnosesControllerRuleOut.');
    }
    if (ruleOutDiagnosisRequestDto === null || ruleOutDiagnosisRequestDto === undefined) {
      throw new Error('Required parameter ruleOutDiagnosisRequestDto was null or undefined when calling diagnosesControllerRuleOut.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rule-out`,
        data: ruleOutDiagnosisRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search diagnoses
   * @param searchTerm Search term for diagnosis element name or code
   * @param patientId Filter by patient ID
   * @param encounterId Filter by encounter ID
   * @param elementIds Filter by element IDs
   * @param status Filter by status
   * @param priority Filter by priority
   * @param limit Number of items per page
   * @param offset Number of items to skip
   */
  public async diagnosesControllerSearch(searchTerm?: string, patientId?: string, encounterId?: string, elementIds?: string, status?: 'preliminary' | 'confirmed' | 'differential' | 'ruled_out' | 'resolved', priority?: 'primary' | 'secondary' | 'tertiary', limit?: number, offset?: number, ): Promise<DiagnosesControllerSearch200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters.append('searchTerm', String(searchTerm));
    }
    if (patientId !== undefined && patientId !== null) {
      localVarQueryParameters.append('patientId', String(patientId));
    }
    if (encounterId !== undefined && encounterId !== null) {
      localVarQueryParameters.append('encounterId', String(encounterId));
    }
    if (elementIds !== undefined && elementIds !== null) {
      localVarQueryParameters.append('elementIds', String(elementIds));
    }
    if (status !== undefined && status !== null) {
      localVarQueryParameters.append('status', String(status));
    }
    if (priority !== undefined && priority !== null) {
      localVarQueryParameters.append('priority', String(priority));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/search?${queryString}` : `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/search`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update diagnosis
   * @param id 
   * @param updateDiagnosisRequestDto 
   */
  public async diagnosesControllerUpdate(id: string, updateDiagnosisRequestDto: UpdateDiagnosisRequestDto, ): Promise<DiagnosesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling diagnosesControllerUpdate.');
    }
    if (updateDiagnosisRequestDto === null || updateDiagnosisRequestDto === undefined) {
      throw new Error('Required parameter updateDiagnosisRequestDto was null or undefined when calling diagnosesControllerUpdate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnoses/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateDiagnosisRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
